module.exports = __webpack_public_path__ + "img/pc_bg.4feef8a.webp";